import { createFileRoute } from '@tanstack/react-router';
import { ContactWall } from '@/components/wall/contact-wall';

export const Route = createFileRoute('/wall/contact')({
  component: ContactWall,
});
